import { css } from '@emotion/react';
import * as React from 'react';
import { useActions, useSelector } from '../../state';
import { CadasterEnabledAddress } from '../CadasterAddressInput';

export const CompanyContactFormCadaster: React.FC = () => {
  const info = useSelector(e => e.editor.coreInfo);
  const { editorActions } = useActions();

  return (
    <form
      noValidate={true}
      onSubmit={evt => {
        evt.preventDefault();
      }}
      css={css`
        [role='listbox'] {
          border-width: 1px;
          border-radius: 0 0 4px 4px;
        }

        li {
          border-radius: 4px;
        }
      `}
    >
      <CadasterEnabledAddress
        initialAddress={info.cadasterAddress ?? ''}
        hasValidCadasterAddress={info.cadasterAddress != null}
        label="Selskapets adresse"
        onSelectionChange={e => {
          if (e === undefined) {
            editorActions.setCoreInfo({ cadasterAddress: undefined });
          } else {
            editorActions.setCoreInfo({
              cadasterAddress: `${e.addressText}, ${e.postalCode} ${e.postalPlace}`,
              address: e.addressText,
              postalCode: e.postalCode,
            });
          }
        }}
      />
    </form>
  );
};
